import { SelectPoint3d } from 'iconoir-react';
import { renderToString } from 'react-dom/server';

import { getIconByName } from '~/scenes/Build/scenes/FlowBuilder/CapsuleDesign/components/Save/helpers/iconoirIcons';

interface CapsuleProps {
  header?: string;
  background?: string;
  icon?: string;
}

interface CreateIconCapsuleProps extends CapsuleProps {
  accent?: string;
}

const defaultHeader =
  'data:image/jpg;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAAAUCAIAAACCmL1JAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAi0lEQVR4nO2WywoAIQhF+/5+uhYzDPYCZ9G9F/SsJAT1QFapiaGwG9AidQygdTQDuLQHqI62gKzuQUKHjh2yjq0XZEsTEjrWHGRXFr6OUxqysQ++Dikj0jrwRsjfsGfg7fqgGJHQMQWp4439t+kSQjrqn+VyCfQq9ZwE1XGaM4qO6n41gq5SNVLHQAf7FRHjVjAKhAAAAABJRU5ErkJggg==';

const capsule = ({
  header,
  background = '#ffffff',
  icon
}: CapsuleProps): JSX.Element => {
  const iconToUse = icon;
  const IconComponent = iconToUse
    ? getIconByName(iconToUse) || SelectPoint3d
    : SelectPoint3d;

  return (
    <svg
      width='90px'
      height='78px'
      viewBox='0 0 90 78'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <rect
        id='background'
        fill={background}
        x='0'
        y='0'
        width='90'
        height='90'
      />
      <image
        id='header'
        x='0'
        y='0'
        width='90'
        height='20'
        transform='translate(0 0) scale(1)'
        href={header || defaultHeader}
      />
      <g transform='translate(25 30.5)'>
        <IconComponent width={40} height={40} />
      </g>
    </svg>
  );
};

const createIconCapsule = (
  props: CreateIconCapsuleProps
): string | undefined => {
  try {
    const svg = renderToString(capsule(props));
    const newSvg = svg.replace('currentColor', props.accent || '#000000');
    return encodeURIComponent(newSvg);
  } catch (e) {
    // console.log(e);
  }
};

export default createIconCapsule;
